export default {
  tooltips: {
    expand: "Expand",
    collapse: "Collapse",
    delete: "Delete",
    duplicateAddressMark: "Duplicate Address Mark",
  },
  remark: "Remark",
};
